import script from "./Vortex.vue?vue&type=script&lang=js"
export * from "./Vortex.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__